import { render, staticRenderFns } from "./PripoistenieControl.vue?vue&type=template&id=fd2cae56&"
import script from "./PripoistenieControl.vue?vue&type=script&lang=js&"
export * from "./PripoistenieControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VDataTable,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd2cae56')) {
      api.createRecord('fd2cae56', component.options)
    } else {
      api.reload('fd2cae56', component.options)
    }
    module.hot.accept("./PripoistenieControl.vue?vue&type=template&id=fd2cae56&", function () {
      api.rerender('fd2cae56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/poistenie/PripoistenieControl.vue"
export default component.exports